import { useState } from 'react';
import { Info, ChevronDown, ChevronUp } from 'lucide-react';

const DISCLAIMER = `Diese Anwendung dient ausschließlich als Orientierungshilfe zur Berechnung des Urlaubsanspruchs.
Die Berechnungen ersetzen keine rechtliche oder steuerliche Beratung.
Bei komplexen Arbeitsverhältnissen oder Streitfällen empfehlen wir die Konsultation eines Fachanwalts für Arbeitsrecht.`;

export function Footer() {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-white/10 mt-auto no-print">
      <div className="container mx-auto px-4 py-4">
        {/* Disclaimer Toggle */}
        <button
          onClick={() => setShowDisclaimer(!showDisclaimer)}
          className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors mb-2"
        >
          <Info className="w-4 h-4" />
          <span>Rechtlicher Hinweis</span>
          {showDisclaimer ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </button>

        {/* Disclaimer Text */}
        {showDisclaimer && (
          <div className="border border-amber-300/60 bg-amber-50 dark:border-amber-500/20 dark:bg-amber-900/10 rounded-lg p-4 mb-4 animate-fade-in">
            <p className="text-xs text-amber-800 dark:text-amber-200">{DISCLAIMER}</p>
          </div>
        )}

        {/* Footer Links */}
        <div className="flex flex-wrap items-center justify-between gap-4 text-xs text-gray-500 dark:text-gray-400">
          <div className="flex items-center gap-4">
            <span>Stundenliste v1.0</span>
            <span className="hidden sm:inline">|</span>
            <span className="hidden sm:inline">
              Berechnung nach BUrlG (Bundesurlaubsgesetz)
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
